import {Log} from '../../shared/log';
const log = new Log('AddVehicleRegistrationHandler');

import {AddVehicleRegistrationCommand} from './AddVehicleRegistrationCommand';
import {Injectable} from '@angular/core';
import {UserEvents} from '../../services/user/user.events';
import {UserService} from '../../services/user/user.service';
import { IVehicleRegistration } from '../../interfaces/interfaces';

@Injectable()
export class AddVehicleRegistrationHandler {
    constructor (
        private userService: UserService,
        private userEvents: UserEvents,
    ) { }

    handle (command: AddVehicleRegistrationCommand): Promise<IVehicleRegistration> {
        return this.userService.addVehicleRegistration(command.registrationNumber)
            .then((details) => {
                this.userEvents.vehicleRegistrationChanged.emit({ new: command.registrationNumber.value});
                return Promise.resolve(details);
            })
            .catch(error => {
                log.error('Failed to add vehicleRegistration', error);
                return Promise.reject(error);
            });
    }
}



// WEBPACK FOOTER //
// ./app/domain/vehicleRegistration/AddVehicleRegistrationHandler.ts